var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.noticeContent)?_c('div',{staticClass:"notice-wrap"},[_c('p',{staticClass:"notice-title"},[_vm._v("刷题公告")]),_c('p',{staticClass:"notice-con",domProps:{"innerHTML":_vm._s(_vm.noticeContent)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }